module.exports = __webpack_public_path__ + "img/3_1.24bf7108.png";